import { ASPECT_RATIO } from "@circle-react/components/constants";
import { CoverImageInput } from "@circle-react-uikit/CoverImageInput";
import { Form } from "@circle-react-uikit/Form";
import { CoverImageWithButtons } from "../CoverImageWithButtons";

export interface FormValues {
  cover_image: string;
}

export interface CoverImageFormProps {
  isLoading?: boolean;
  onDelete: () => void;
  onSubmit: (values: FormValues) => void;
  url: string;
}

export const CoverImageForm = ({
  isLoading = false,
  onDelete,
  onSubmit,
  url,
}: CoverImageFormProps) => (
  <Form<FormValues> onSubmit={onSubmit}>
    {({ triggerFormSubmit }) => (
      <CoverImageInput
        name="cover_image"
        renderImagePreview={() => <CoverImageWithButtons url={url} />}
        onImageAttachSuccess={triggerFormSubmit}
        showAddCoverBtn={false}
        aspectRatio={ASPECT_RATIO.COVER_V3}
        renderer={({ value, processing, imageUrl, handleChangeCoverClick }) => (
          <CoverImageWithButtons
            url={value ? imageUrl : url}
            isLoading={processing || isLoading}
            onChange={handleChangeCoverClick}
            onDelete={onDelete}
          />
        )}
      />
    )}
  </Form>
);
